export default __webpack_public_path__ + "static/media/Step.43ee50b9.png";